<div class="our-brands-mini mx-auto">
  <div class="label position-absolute top-0 translate-middle bg-white p-2" i18n="common slider: brands">Brands</div>
  <div class="inner d-flex align-items-center h-100 px-3 text-center">
    <swiper #swiper [config]="config" (swiper)="onSwiper($event)" (slideChange)="onSlideChange()">
      <ng-template swiperSlide *ngFor="let brand of brands">
        <div class="tile">
          <img class="brand-slide-img" src="./assets/images/brands/{{locale}}/{{brand.image}}" alt="">
        </div>
      </ng-template>
    </swiper>
  </div>
</div>